export const SUPPORT_VIDEOS_CATEGORY_NAME = 'Support Videos'

const categoryTitles = category => [
  category?.sourceTitle,
  category?.attributes?.title,
  category?.title,
  typeof category === 'string' ? category : null,
].map(value => `${value || ''}`.trim()).filter(Boolean)

export const isSupportVideosCategory = category => categoryTitles(category).some(title => (
  title.toLowerCase() === SUPPORT_VIDEOS_CATEGORY_NAME.toLowerCase()
))

export const isVideoMedia = media => {
  const mime = `${media?.mime || media?.attributes?.mime || ''}`.toLowerCase()
  const url = `${media?.url || media?.attributes?.url || ''}`.toLowerCase().split('?')[0].split('#')[0]

  return mime.startsWith('video/') || /\.(mp4|m4v|mov|webm|mpeg|mpg|avi|mkv|wmv)$/.test(url)
}

export const buildSupportVideoRoute = ({ categoryId, contentId }) => (
  `/sub-category/${categoryId}/service-supports/${contentId}`
)
